export const BarMenuTranslationEN = {
  BarMenuTranslationFeature: {
    Text: {
      title: 'Bar information list',
    },
    Button: {
      add_new: 'New addition',
      detail: 'detailed',
      delete: 'delete',
      restore: 'Restoration',
      target_menu: 'Target menu list',
      add: 'add',
    },
    Table: {
      select: '選択',
      bar_guide_code: 'コード',
      bar_guide_name: 'ご案内名',
      bar_guide_type: 'タイプ',
      remark: '備考',
      target_menu: '対象メニュー',
    },
    DialogConfirm: {
      btn_cancel: 'Cancel',
      btn_save: 'OK',
      title: 'Deletion confirmation',
      message: 'Are you want to delete the selected item?',
    },
  },
};
